import React from 'react'
import { connect } from 'react-redux'

import meanBy from 'lodash/meanBy'

import {
  nowSelector,
  dateSelector,
} from '../../reducers/uiReducer'

import {
  dateTidesSelector,
  tideHeightRangeSelector,
} from '../../reducers/tidesReducer'

import styles from './TideSummary.module.css'




// Redux connect

export default connect(
  state => {
    const now = nowSelector(state)
    const date = dateSelector(state)
    const tides = dateTidesSelector(state, 'THREE_DAY')
    const tideHeightRange = tideHeightRangeSelector(state)

    return { now, date, tides, tideHeightRange }
  }
)(TideSummaryView)




// View logic

function TideSummaryView({now, date, tides, tideHeightRange}) {

  if (tides.length === 0) return null

  if (now.isSame(date, 'day')) {
    // Get previous and next 2 tides
    const nextIndex    = tides.findIndex(tide => tide.moment > now)
    const prevTide     = tides[nextIndex-1]
    const nextTide     = tides[nextIndex]
    const nextNextTide = tides[nextIndex+1]

    // Time calculations
    const timeSincePrevTideInMinutes = now.diff(prevTide.moment, 'minute')
    const timeToNextTideInMinutes = nextTide.moment.diff(now, 'minute')

    // Return message based on where `now` is in relation to prev and next tides
    if (timeSincePrevTideInMinutes < 30)
      return slackMessage(prevTide, nextTide)
    else if (timeToNextTideInMinutes < 30)
      return slackMessage(nextTide, nextNextTide)
    else
      return flowMessage(now, nextTide)
  }
  else {
    return notTodayMessage(now, date, tides, tideHeightRange)
  }

}




// Message views

function slackMessage(currentTide, nextTide) {
  const currentTideType = currentTide.type.toLowerCase()
  const nextTideType    = nextTide.type.toLowerCase()
  const nextTideTime    = nextTide.moment.format('h:mm a')

  return (
    <div className={styles.container}>
      It's currently <mark>{currentTideType} tide</mark>. The next {nextTideType} tide is at {nextTideTime}.
    </div>
  )
}

function flowMessage(now, nextTide) {
  const direction   = (nextTide.type === 'High') ? 'coming in' : 'going out'
  const type        = nextTide.type.toLowerCase()
  const timeInWords = now.to(nextTide.moment)

  return (
    <div className={styles.container}>
      The tide is <mark>{direction}</mark>. It'll be {type} tide {timeInWords}.
    </div>
  )
}

const EXTREME_TOLERANCE = 0.055

function notTodayMessage(now, date, tides, tideHeightRange) {

  // Filter to select tides for selected day
  const dateTides = tides.filter(tide => tide.moment.isSame(date, 'day'))

  // Crude approximation for Mean High High Water (MHHW) until we start fetching
  // tide station datums (scheduled for v1.2)
  const fakeMHHW = tideHeightRange.max - (tideHeightRange.max - tideHeightRange.min) * 0.15

  // Average the percent differences of all of the tide heights from their
  // average.
  const extremeFactor = meanBy(dateTides, tide => {
    return tide.type === 'High'
      ? (tide.v - fakeMHHW) / fakeMHHW
      : (0 - tide.v) / fakeMHHW
  })

  const extremity
    = extremeFactor > EXTREME_TOLERANCE
    ? <span><mark>more extreme</mark> than usual</span>
    : extremeFactor < -EXTREME_TOLERANCE
    ? <span><mark>more mild</mark> than usual</span>
    : <span><mark>about average</mark></span>

  const willBeOrWere = date.isAfter(now) ? 'will be' : 'were'
  const formattedDate = date.format('MMMM Do') // July 21st

  return (
    <div className={styles.container}>
      The tides {willBeOrWere} {extremity} on {formattedDate}.
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/DayPage/TideSummary.js